import React, { useEffect } from 'react';

import cx from 'classnames';
import { isEmpty, omit } from 'ramda';

import Button from 'components/shared/Button';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import Loader from 'components/shared/Loader';

import { getUniqueFlightAPIKey } from '../utils';
import s from './index.module.css';
import { Item } from './Item';
import { NoResultFound } from './NoResultFound';

export function Result({ data, activeType, onAdd, submitting, activeItems, setActiveItems }) {
  const isNoData = data?.length === 0;

  // To update the selected flight if it has been rescheduled
  useEffect(() => {
    data?.forEach((flight) => {
      const key = getUniqueFlightAPIKey(flight);

      if (activeItems[key] === null) {
        setActiveItems((prev) => ({ ...prev, [key]: flight }));
      }
    });
  }, [data]);

  const handleAddActiveItem = (item) => {
    const key = getUniqueFlightAPIKey(item);
    setActiveItems((prev) => (key in prev ? omit([key], prev) : { ...prev, [key]: item }));
  };

  const handleAdd = () => {
    if (isEmpty(activeItems)) return;
    onAdd(Object.values(activeItems));
  };

  if (!data) return null;
  const isDisabled = isNoData || submitting || isEmpty(activeItems);

  return (
    <div className={cx(s.wrapper, 'custom-add-flights-result')}>
      {submitting && <Loader isFillBlock />}
      {isNoData ? (
        <NoResultFound />
      ) : (
        <div className={cx(s.list, 'custom-add-flights-list')}>
          {data.map((flight, i) => (
            <Item
              key={i}
              item={flight}
              activeType={activeType}
              setActiveItems={handleAddActiveItem}
              checked={getUniqueFlightAPIKey(flight) in activeItems}
            />
          ))}
        </div>
      )}

      <FormActions isRight>
        <Button htmlType="button" type={isDisabled ? 'default' : 'primary'} disabled={isDisabled} onClick={handleAdd}>
          Add Flight
        </Button>
      </FormActions>
    </div>
  );
}
